// extracted by mini-css-extract-plugin
export default {"overflowTable":"TableLevelSpecialCampaign_overflowTable__PhMqq"};